/**
 * Pouls brand mark — the yellow rounded square containing the logo glyph,
 * with the "Pouls" wordmark on the right. Used by the top nav, auth pages,
 * and payment success screen so the brand stays consistent everywhere.
 */
import logoMark from "@/assets/pouls-logo.png";

const SIZE_PRESETS = {
  sm: { box: "w-7 h-7 rounded-lg", img: "w-5 h-5", text: "text-lg" },
  md: { box: "w-9 h-9 rounded-xl", img: "w-6 h-6", text: "text-2xl" },
  lg: { box: "w-16 h-16 rounded-2xl", img: "w-11 h-11", text: "text-3xl" },
};

export const BrandMark = ({ size = "md", showWordmark = true, className = "" }) => {
  const s = SIZE_PRESETS[size] || SIZE_PRESETS.md;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-mark">
      <div className={`${s.box} bg-primary flex items-center justify-center shadow-lg shadow-primary/30`}>
        <img
          src={logoMark}
          alt=""
          aria-hidden="true"
          className={s.img}
          style={{ filter: "brightness(0)" }}
        />
      </div>
      {showWordmark && (
        <h1 className={`font-publica ${s.text} font-bold tracking-tight`}>Pouls</h1>
      )}
    </div>
  );
};

export default BrandMark;
